import { formatDistanceToNow, isToday, isYesterday } from 'date-fns';
import { Icon } from '../../../components/Icon';
import { Tile } from '../../../components/Tile';
import { trackSharepointDownload } from '../../../utils/principal-service/event-endpoints';
import { Principal } from '../../../utils/types';
import { DocumentFile } from './DocumentFile';
import { mimeTypeIcons } from './SharedDocumentItem';
import { useTranslation } from 'react-i18next';

export const LatestActivity = ({
  item,
  currentPrincipal,
}: {
  item: DocumentFile;
  currentPrincipal: Principal;
}) => {
  const { t } = useTranslation();
  const lastModifiedRelative = item.lastModified
    ? isToday(item.lastModified)
      ? t('components:sharepoint:lastModified:today')
      : isYesterday(item.lastModified)
      ? t('components:sharepoint:lastModified:yesterday')
      : formatDistanceToNow(item.lastModified, { addSuffix: true })
    : t('components:sharepoint:lastModified:unknown');

  return (
    <Tile
      key={item.id}
      tileLink={item.url ?? ''}
      onClick={() => {
        trackSharepointDownload({
          principalId: currentPrincipal.id,
          fileName: item.name ?? '',
        });
      }}
    >
      <div className=" mb-3 flex  w-full ">
        <div className="h-4 w-4 shrink-0">
          <Icon
            name={mimeTypeIcons[item.mimeType ?? ''] ?? 'File'}
            inline={true}
          />
        </div>
        <div className="text-grey-700 truncate pl-2">{item.name}</div>
      </div>
      <div className="text-grey-600 flex justify-between text-xs">
        <div>{lastModifiedRelative}</div>
        <div>{item.owner}</div>
      </div>
    </Tile>
  );
};
